<template>
  <CommercialServicePage v-if="kind === 'commercial'" />
  <ServiceLocationPage v-else-if="kind === 'district'" />
  <div v-else class="p-20 text-center">
    <p class="mb-4">Service not found.</p>
    <RouterLink to="/services" class="text-light-purple">Back to services</RouterLink>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import CommercialServicePage from './CommercialServicePage.vue'
import ServiceLocationPage from './ServiceLocationPage.vue'
import { getCommercialService } from '../config/commercialServices'
import { getServiceLocation } from '../config/locations'

export default {
  name: 'ServiceSlugPage',
  components: { CommercialServicePage, ServiceLocationPage },
  setup() {
    const route = useRoute()
    const kind = computed(() => {
      const slug = route.params.slug
      if (getCommercialService(slug)) return 'commercial'
      if (getServiceLocation(slug)) return 'district'
      return null
    })
    return { kind }
  },
}
</script>
